import * as firebase from 'firebase'
// import { state } from 'fs/promises';

export default {
  state: {
    loadedNotice: ''
  },
  mutations: {
    setLoadedNotice (state, payload) {
      state.loadedNotice = payload
    },
    createNotice (state, payload) {
      state.loadedNotice = payload
    },
    updateNotice (state, payload) {
      state.loadedNotice = payload.noticeName
    },
    deleteNotice (state, payload) {
      state.loadedNotice = null
    }
  },
  actions: {
    loadedNotice ({ commit }) {
      commit('setLoading', true)
      firebase.database().ref('notice').once('value')
        .then((data) => {
          const obj = data.val()
          console.log(obj)
          commit('setLoadedNotice', obj)
          commit('setLoading', false)
        })
        .catch(
          (error) => {
            console.log(error)
            commit('setLoading', true)
          }
        )
    },
    createNotice ({ commit, getters }, payload) {
      const notice = {
        noticeName: payload
        // noticeId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
      }
      firebase.database().ref('notice').update(notice)
        .then(() => {
          commit('createNotice', {
            ...notice
          })
        })
        .catch((error) => {
          console.log(error)
        })
      // Reach out to firebase and store it
      // commit('createNotice', notice)
    },
    // May have to create a separate Action for each updated item (i.e. updateNoticeNotice, updateNoticeDescription, etc)
    updateNoticeData ({ commit }, payload) {
      commit('setLoading', true)
      firebase.database().ref('notice').update(payload)
        .then(() => {
          commit('setLoading', false)
          commit('updateNotice', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    deleteNoticeData ({commit}, payload) {
      commit('setLoading', true)
      console.log('Payload: ' + JSON.stringify(payload))
      firebase.database().ref('notice').remove()
      .then(() => {
        commit('setLoading', false)
        commit('deleteNotice', payload)
      })
      .catch(error => {
        console.log(error)
        commit('setLoading', false)
      })
    }
  },
  getters: {
    loadedNotice (state) {
      return state.loadedNotice
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/alert/index.js